import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';

import { TooltipPlacement, capraIconGsheetSync } from '@mode/capra';
import { formatTimeAgo } from '@mode/shared/util-js';

@Component({
  selector: 'mode-dataset-sync-button',
  templateUrl: './dataset-sync-button.component.html',
  styleUrls: ['./dataset-sync-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DatasetSyncButtonComponent implements OnChanges {
  @Input({ required: true }) lastSynced = Date.now();
  @Input({ required: true }) isSyncing = false;
  @Input({ required: true }) isSheetsEnabled = false;
  @Output() syncClicked: EventEmitter<void> = new EventEmitter<void>();

  tooltipContent = '';
  readonly tooltipPlacement: TooltipPlacement = 'bottom';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['lastSynced']?.currentValue) {
      this.tooltipContent = `
        <p style='margin: 0 0 8px; padding-bottom: 8px; font-weight: 500; border-bottom: 1px solid #6C6E6B;'>
          Pull data in from the<br> underlying Google Sheet
        </p>

        <p style='display: flex; margin: 0; color: #CED1CD;'>
          <span style='display: inline-block; width: 16px; height: 16px; margin-right: 8px;'>${
            capraIconGsheetSync.data
          }</span>
          <span>Synced ${formatTimeAgo(this.lastSynced)}</span>
        </p>
        `;
    }
    if (changes['isSheetsEnabled']?.currentValue === false) {
      this.tooltipContent = `
        <p style='text-align: left; margin: 0;'>
        The Google Sheets integration is disabled for this Workspace. To sync, enable the feature and make sure the Dataset creator reconnects to Google.
        </p>
        `;
    }
  }

  onSyncClicked() {
    this.syncClicked.emit();
  }
}
